export const pluralize = (word: string, count: number): string => {
  if (count === 1) return word;

  // Specific words we exclude (for reasons I'm not sure why)
  const EXCLUDE_WORDS = ["projects", "security"];

  // Words that don't use a plural form (this is not a complete list)
  const MASS_NOUNS = ["hardware", "software"];

  const IGNORE_WORDS = [...EXCLUDE_WORDS, ...MASS_NOUNS];
  if (IGNORE_WORDS.includes(word)) return word;

  const VOWELS = ["a", "e", "i", "o", "u"];
  const isVowel = (char: string) => VOWELS.includes(char);

  const SIBILANTS = ["ch", "j", "s", "sh", "x", "z", "zh"];
  const endsWithSibilant = (word: string) =>
    SIBILANTS.some((s) => word.endsWith(s));

  const endsWithConsonantY = (word: string) =>
    word.endsWith("y") && !isVowel(word.slice(-2, -1));

  if (endsWithConsonantY(word)) {
    return `${word.slice(0, -1)}ies`;
  }

  if (endsWithSibilant(word)) {
    return `${word}es`;
  }

  return `${word}s`;
};
